import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const createOrderProofPayment = async (data: any): Promise<any> => {
  const result = await axios.post(
    `orders/proposals/${data.proposalId}/proof-payment`,
    data
  )
  return result
}

export function useCreateOrderProofPayment() {
  const queryClient = useQueryClient()

  return useMutation(createOrderProofPayment, {
    onSuccess: () => {
      queryClient.invalidateQueries('ordersTracking')
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadAutentiqueSignedProposals')
      queryClient.invalidateQueries('loadHandSignedProposals')

      toast.success('Comprovante enviado com sucesso!', {
        toastId: 'ordersProposalProofPayment'
      })
    },
    onError: (error: unknown) => {
      console.error(error)

      toast.error('Não foi possível enviar o comprovante!', {
        toastId: 'ordersProposalProofPayment'
      })
    }
  })
}
